import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridItemChangeEvent } from '@progress/kendo-react-grid';
import { useCallback, useRef, useState } from 'react';
import uuid from 'react-uuid';
import { round } from 'src/utils';
import { truncatedTwoDecimalNumber } from 'src/utils/number';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../invoice_details/InvoiceDetailsContext';
import InvoiceBudgetPeriodTable from './InvoiceBudgetPeriodTable';

const ViewInvoiceBudgetPeriodMain = () => {
  const invoiceBudgetPeriodDataWithErrors = useContextSelector(
    InvoiceContext,
    (value) => value.invoiceBudgetPeriodDataWithErrors
  );

  const setInvoiceBudgetPeriods = useContextSelector(
    InvoiceContext,
    (value) => value.setInvoiceBudgetPeriods
  );

  const setDistributionType = useContextSelector(
    InvoiceContext,
    (value) => value.setDistributionType
  );

  const distributionType = useContextSelector(InvoiceContext, (value) => value.distributionType);
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);
  const [isClick, setIsClick] = useState(false);

  const handleAddRow = useCallback(() => {
    setInvoiceBudgetPeriods((prev) => [
      ...prev,
      {
        glPeriodId: 0,
        percentageAmount: 0,
        amount: 0,
        isDeletable: true,
        expanded: false,
        rowId: uuid(),
        items: [],
        isNew: true,
      },
    ]);
  }, [setInvoiceBudgetPeriods]);

  const handleDistributionChange = (e: DropDownListChangeEvent) => {
    setDistributionType(e.value);
  };

  const handleAutoDistributution = useCallback(() => {
    setInvoiceBudgetPeriods((prev) => {
      const prevData = [...prev];
      const total = prevData.length;
      const amount = truncatedTwoDecimalNumber(Number(invoice.totalCostAmt) / total);
      let remainingAmount = round(Number(invoice.totalCostAmt) - amount * total, 2);
      const newData = prevData.map((item, index) => {
        let newAmount = amount;
        if (remainingAmount > 0) {
          newAmount = round(newAmount + 0.01, 2);
          remainingAmount = round(remainingAmount - 0.01, 2);
        } else if (remainingAmount < 0) {
          newAmount = round(newAmount - 0.01, 2);
          remainingAmount = round(remainingAmount + 0.01, 2);
        }
        const percentage =
          Number(invoice.totalCostAmt) === 0
            ? round(100 / prevData.length, 2)
            : round((newAmount / Number(invoice.totalCostAmt)) * 100, 2);
        return {
          ...item,
          percentageAmount: percentage,
          amount: newAmount,
        };
      });
      return newData;
    });
  }, [invoice.totalCostAmt, setInvoiceBudgetPeriods]);
  const timerRef = useRef<number | undefined>();

  const handleItemChange = useCallback(
    (e: GridItemChangeEvent) => {
      const { field = '', value } = e;
      const { rowId } = e.dataItem;

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      setInvoiceBudgetPeriods((prev) =>
        prev.map((item) => ({
          ...item,
          ...(rowId === item.rowId && {
            [field]: value,

            ...(field === 'percentageAmount'
              ? {
                  amount: round((Number(invoice.totalCostAmt) * Number(value)) / 100, 2),
                }
              : {}),
            ...(field === 'amount'
              ? {
                  amount: value,
                  percentageAmount: round((Number(value) / Number(invoice.totalCostAmt)) * 100, 2),
                }
              : {}),
          }),
        }))
      );
    },
    [invoice.totalCostAmt, setInvoiceBudgetPeriods]
  );
  return (
    <InvoiceBudgetPeriodTable
      dataSource={invoiceBudgetPeriodDataWithErrors}
      isTableLoading={false}
      handleItemChange={handleItemChange}
      handleAddRow={handleAddRow}
      handleAutoDistributution={handleAutoDistributution}
      distributionType={distributionType}
      onDistributionChange={handleDistributionChange}
      isClick={isClick}
      setIsClick={setIsClick}
    />
  );
};

export default ViewInvoiceBudgetPeriodMain;
